export default __webpack_public_path__ + "static/media/Logo-footer.762e0fd1.svg";